const AddTipsEndpoint = {
  create (form) {
    return {
      url: '/tips',
      method: 'POST',
      body: JSON.stringify({ tip: form })
    }
  }
}

export default AddTipsEndpoint



// WEBPACK FOOTER //
// ./src/persistence/AddTipEndpoint.js